export { registerDirectionalLight } from '../core/light';
export { registerOrthoCamera } from '../core/camera';
export { registerViewTransform3dPlugin } from '../plugins/builtin-plugin/3dview-transform-plugin';
